/**
 * Badge displaying the count of active filters.
 *
 * Uses iOS system blue (#007aff) for consistent visibility in both light and dark modes.
 * @module components/shared/ActiveFilterCountBadge
 */

import React, { memo } from "react";

import { Box } from "@/components/atoms/Box";
import { Text } from "@/components/atoms/Text";

/**
 *
 */
interface ActiveFilterCountBadgeProps {
  /** Number of active filters to display */
  readonly count: number;
}

/**
 * Circular badge showing the number of active filters.
 *
 * Renders nothing when count is 0 or less.
 * @param root0 - Component props
 * @param root0.count - Number of active filters
 */
const ActiveFilterCountBadge = ({ count }: ActiveFilterCountBadgeProps) => {
  if (count <= 0) return null;

  return (
    <Box className="h-5 min-w-5 items-center justify-center rounded-full bg-accent-primary px-1">
      <Text
        variant="micro-strong"
        className="text-center text-content-on-accent"
      >
        {count}
      </Text>
    </Box>
  );
};

ActiveFilterCountBadge.displayName = "ActiveFilterCountBadge";

export default memo(ActiveFilterCountBadge);
